import React, { useState } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { AddItemOpeningQtyApi } from "../../ApiRequests";
import AuthBtn from "../Buttons/AuthBtn";
import ItemSelector from "../Selector/ItemSelector";
import { fetchProducts } from "../../store/Slices/ProductSlice";

// Get user data with null checks
const userData = JSON.parse(localStorage.getItem("user")) || {};
const { branchId } = userData;

const AddOpeningQtyItemModal = ({ Open, setOpen }) => {
  const [OpeningQty, setOpeningQty] = useState("");
  const [SelectedProduct, setSelectedProduct] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let payload = {
      amount: OpeningQty,
    };

    if (!SelectedProduct || !OpeningQty) WarningToast("Valid Details Required");
    else {
      try {
        let response = await AddItemOpeningQtyApi(SelectedProduct._id, payload);

        if (response.data.success) {
          setOpen(false);
          SuccessToast("Opening Balance added successfully");
          dispatch(fetchProducts());
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        ErrorToast(err.response.data.error?.msg);
        // ErrorToast("Failed to add payment");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Add Opening Quantity
        </h1>
        <div className="flex gap-4 max696:flex-col px-10 max696:max-h-[70vh] max696:overflow-y-auto">
          <div className="flex flex-col gap-y-4">
            <ItemSelector
              setSelectedProduct={setSelectedProduct}
              SelectedProduct={SelectedProduct}
            />
            <AuthInput
              label="Opening Qty"
              placeholder="Enter Opening Qty"
              Value={OpeningQty}
              setValue={setOpeningQty}
            />
          </div>
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Add Account"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default AddOpeningQtyItemModal;
